module.exports = __webpack_public_path__ + "static/media/intermediate.21b1e942.png";